export default {
    init() {
        let multi_dropdowns = document.getElementsByClassName('multi-dropdown-container');
        if(multi_dropdowns) {
            $(document).mouseup(function(e) {
                var container = $(".multi-dropdown-container");

                // if the target of the click isn't the container nor a descendant of the container
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    for(let j = 0; j < multi_dropdowns.length; j++) {
                        let multi_dropdown = multi_dropdowns[j];
                        multi_dropdown.getElementsByClassName('multi-dropdown-controls')[0].classList.add('inactive');
                    }
                }
            });
            
            for(let i = 0; i < multi_dropdowns.length; i++) {
                let multi_dropdown = multi_dropdowns[i];
                this.option_controls(multi_dropdown);
                let controls = multi_dropdown.getElementsByClassName('multi-dropdown-controls')[0];
                controls.addEventListener('click', (e) => {
                    console.log("Controls clicked");
                    controls.classList.toggle('inactive');

                    //closing other multi dropdowns
                    for(let j = 0; j < multi_dropdowns.length; j++) {
                        let compare_dropdown = multi_dropdowns[j];
                        if(compare_dropdown !== controls.parentElement) {
                            compare_dropdown.getElementsByClassName('multi-dropdown-controls')[0].classList.add('inactive');
                        }
                    }
                })
            }
        }
    },
    option_controls(container) {
        let options_container = container.getElementsByClassName('multi-dropdown');
        // let options = options_container.getElementsByClassName('div');
        for(let i = 0; i < options_container.length; i++) {
            let option = options_container[i];
            let text = option.getElementsByTagName('p')[0];
            option.addEventListener('click', (e) => {
                let checkbox_div = option.getElementsByClassName('multi-dropdown__checkbox')[0];
                let input = checkbox_div.getElementsByTagName('input')[0];
                if(input.checked) {
                    text.classList.add('navy');

                    input.addEventListener('change', (e) => {
                        //if the selected checkbox is All AP then tick all the AP checkboxes.
                        if(e.target.value === "All AP" && e.target.checked) {
                            let ap_options = ["Other AP", 'State-maintained AP', 'Independent AP'];
                            ap_options.forEach(ap_option => {
                                let ap_option_input = container.querySelector(`.multi-dropdown__option input[value="${ap_option}"]`);
                                if(ap_option_input) {
                                    ap_option_input.checked = true;
                                    let ap_option_text = ap_option_input.parentElement.getElementsByTagName('p')[0];
                                    if(ap_option_text) {
                                        ap_option_text.classList.add('navy')
                                    }
                                }
                            });
                        }
                    })
                } else {
                    text.classList.remove('navy')
                }
                $(input).trigger('change');
            })
        }
    },
    get_values(name) {
        let query = `input[name="${name}"]`;
        let options = document.querySelectorAll(query);
        if(options) {
            let results = [];
            for(let i = 0; i < options.length; i++) {
                let option = options[i];
                if(option.checked) {
                    results.push(option.value);
                }
            }

            return results;
        }

        return false;
    }
}